<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="payment-component inner-home">
  <div class="container">
    <div class="row no-margin">
      <!--heading section starts here-->
      <div class="col-6 col-sm-2 mt-4 ">
                 <a >
                        <button class="btn btn-primary btn-back top-back-button"
                        
                        (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
                    </a>                    
            </div>

      <div class="col-12 col-sm-8 mt-4">
        <div id="searchResu">Payment</div>
        </div>


      <div class="col-6 col-sm-2 icon-cart mt-4">
        <!--dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations">
        </dmv-shoping-cart-->
      </div>
    </div>
      <!--heading section ends here-->


      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{errorMessage}}
      </div>
      
      <div class="pnp-payment-container" id="pnp-payment-container">
        <!--pnp-payment-token id="payment-iframe" style="width:100%;display:block;" onload=pnpLoad() [agencyid]="pnpPaymentDetails.agencyId" paymentDescriptor="{{pnpPaymentDetails.paymentDescriptor}}" accesstoken="{{pnpPaymentDetails.accesstoken}}" addressLine1="{{pnpPaymentDetails.addressLine1}}" stateCode="{{pnpPaymentDetails.stateCode}}" postalCode="{{pnpPaymentDetails.postalCode}}" city="{{pnpPaymentDetails.city}}"></pnp-payment-token-->
      </div>
      <div class="col-12 col-sm-12 mt-3" *ngIf="userStoreService?.getUserProfile()?.megUserGUID && (dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.reusableFundingToken" >  
        <div class="checkbox-container">
          <label>Save this card or bank account to my profile
              <input type="checkbox" [checked]="savedToProfile"  (change)="savedToProfileChange($event)">
              <span class="checkmark"
              [ngStyle]="savedToProfile?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>   
            </label> 
        </div>
        <div *ngIf="savedToProfile">
          <form autocomplete="off" class="w100 text-left mt-4 mb-b" [formGroup]="saveToProfileForm">
               
          <div class="col-12 col-sm-6 mb-4">
            <div id="firstName">Short Name (Max 20 CHARACTERS)</div>
            <input class="form-control" formControlName="shortName" [ngClass]="{ 'is-invalid': submitted && f.shortName.errors }">
            <div *ngIf="submitted && f.shortName.errors"  class="invalid-feedback">Short Name should be max 20 characters.</div>
          </div>
          </form>
        </div>
    </div>
          <div class="m-auto text-center" >
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>  
                      <a>
              <button class="btn btn-primary btn-continue m-auto" (click)="save()">{{buttonLabel}}
                <i class="fa fa-chevron-right text-right"></i>
              </button>
            </a>
          </div>
      
  </div>
</div>